<template>
    <div>
        <Pane title="重新签章" :showRemarks="false">
            <template>重新发起用印流程，上传修改版文件</template>
        </Pane>

        <div class="container">
            <a-skeleton :loading="loading" :paragraph="{ rows: 8 }">
                <a-form
                    :form="form"
                    :label-col="{ span: 8 }"
                    :wrapper-col="{ span: 12 }"
                    :colon="false"
                >
                    <div class="title" style="margin-top: 0">基本信息</div>
                    <div class="wrapper">
                        <a-row>
                            <a-col :span="12">
                                <a-form-item label="项目名称" prop="basic_projectName">
                                    <a-input v-decorator="['basic_projectName']" placeholder="自动生成" disabled />
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="设计编号" prop="basic_designNo">
                                    <a-input v-decorator="['basic_designNo']" placeholder="自动生成" disabled />
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="项目负责人" prop="basic_prjLeader">
                                    <a-input v-decorator="['basic_prjLeader']" disabled/>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="设计专业" prop="basic_majorName">
                                    <a-input v-decorator="['basic_majorName']" disabled/>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="分项名称" prop="basic_subName">
                                    <a-input v-decorator="['basic_subName']" disabled/>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="分项号" prop="basic_subCode">
                                    <a-input v-decorator="['basic_subCode']" disabled/>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="申请人" prop="basic_applicant">
                                    <a-input v-decorator="['basic_applicant']" disabled/>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="申请部门" prop="basic_applyDept">
                                    <a-input v-decorator="['basic_applyDept']" disabled/>
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </div>

                    <div class="title">申请信息</div>
                    <div class="wrapper">
                        <a-row :gutter="16">
                            <a-col :span="12">
                                <a-form-item label="出图章" prop="stampDesignId1">
                                    <a-select v-decorator="['stampDesignId1', { rules: [{ required: true, message: '请选择出图章' }] }]" placeholder="请选择" allow-clear>
                                        <a-select-option v-for="item in stampDesignList" :key="item.id" :value="item.id">{{ item.major }}</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="出图章 2" prop="stampDesignId2">
                                    <a-select v-decorator="['stampDesignId2']" placeholder="请选择" allow-clear>
                                        <a-select-option v-for="item in stampDesignList" :key="item.id" :value="item.id">{{ item.major }}</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="注册章" prop="stampRegisterId1">
                                    <div style="display: flex; align-items: center;">
                                        <a-select v-decorator="['stampRegisterId1', { rules: [{ required: true, message: '请选择注册章' }] }]" placeholder="请选择" allow-clear style="flex: 1;">
                                            <a-select-option v-for="item in stampRegisterList" :key="item.id" :value="item.id">{{ item.major }}</a-select-option>
                                        </a-select>
                                        <a-checkbox v-model="filterByMajor1" style="margin-left: 8px; white-space: nowrap;">按专业过滤</a-checkbox>
                                    </div>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="注册章 2" prop="stampRegisterId2">
                                    <div style="display: flex; align-items: center;">
                                        <a-select v-decorator="['stampRegisterId2']" placeholder="请选择" allow-clear style="flex: 1;">
                                            <a-select-option v-for="item in stampRegisterList" :key="item.id" :value="item.id">{{ item.major }}</a-select-option>
                                        </a-select>
                                        <a-checkbox v-model="filterByMajor2" style="margin-left: 8px; white-space: nowrap;">按专业过滤</a-checkbox>
                                    </div>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="图纸张数">
                                    <span>{{ detail?.drawingCount }}</span>
                                </a-form-item>
                            </a-col>
                            <!--          <a-col :span="12">-->
                            <!--            <a-form-item label="图纸类型" prop="drawingType">-->
                            <!--              <a-select v-decorator="['drawingType']" placeholder="请选择" allow-clear>-->
                            <!--                <a-select-option v-for="item in drawingTypeList" :key="item.value" :value="item.value">{{ item.name }}</a-select-option>-->
                            <!--              </a-select>-->
                            <!--            </a-form-item>-->
                            <!--          </a-col>-->
                            <a-col :span="12">
                                <a-form-item label="出图日期" prop="drawingDate">
                                    <a-date-picker v-decorator="['drawingDate', { rules: [{ required: true, message: '请选择出图日期' }] }]" style="width: 100%" placeholder="请选择日期" />
                                </a-form-item>
                            </a-col>
                            <a-col :lg="24" :md="24" :sm="24">
                                <a-form-item :label-col="{ span: 4 }" :wrapper-col="{ span: 16 }" label="出图用途" :colon="false" prop="purposeValues">
                                    <a-checkbox-group v-decorator="['purposeValues', { rules: [{ required: true, message: '请选择出图用途' }] }]" :options="checkboxOptions" />
                                </a-form-item>
                            </a-col>
                            <a-col :lg="24" :md="24" :sm="24">
                                <a-form-item :label-col="{ span: 4 }" :wrapper-col="{ span: 16 }" label="备注" prop="remark">
                                    <a-textarea v-decorator="['remark']" :rows="3" placeholder="请输入备注" />
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </div>
                    <div class="title">附件</div>
                    <div class="wrapper">
                        <a-table
                            v-if="fileList.length"
                            bordered
                            :data-source="fileList"
                            :pagination="false"
                            :rowKey="(record, index) => record.id || index"
                        >
                            <a-table-column title="文件名称">
                                <template slot-scope="text, record">
                                    <template v-if="record.completePath">
                                        <a :href="record.completePath" target="_blank">{{ record.name }}</a>
                                    </template>
                                    <span v-else>{{ record.name }}</span>
                                </template>
                            </a-table-column>
                            <a-table-column title="最终版文件名称">
                                <template slot-scope="text, record">
                                    <span>{{ record.finalName || '-' }}</span>
                                </template>
                            </a-table-column>
                            <a-table-column title="操作" width="150" align="center">
                                <template slot-scope="text, record, index">
                                    <FileUpload :multiple="false" @uploaded="(list) => handleFinalUpload(list, index)">
                                        <a-button type="link" icon="upload">{{ record.finalId ? '重新上传' : '上传' }}</a-button>
                                    </FileUpload>
                                </template>
                            </a-table-column>
                        </a-table>
                    </div>
                    <div class="title">审批相关人员</div>
                    <div class="wrapper">
                        <a-row>
                            <a-col :lg="12" :md="12" :sm="24" v-for="(user, i) in stampUsers" :key="i">
                                <a-form-item :label="typeLabel(user.type)">
                                    <EmployeeSelector
                                        :single="true"
                                        :disabled="isRoleDisabled(user.type)"
                                        :value="user.selected ? [user.selected] : []"
                                        @change="(arr) => handleUserChange(i, arr)"
                                    >
                                        <a-button block style="text-align: left" :disabled="isRoleDisabled(user.type)">
                                            <div v-if="user.selected?.name">{{ user.selected.name }}</div>
                                            <div v-else-if="user.username">{{ user.username }}</div>
                                            <div v-else>&nbsp;</div>
                                        </a-button>
                                    </EmployeeSelector>
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </div>



                    <div class="title">图纸清单</div>
                    <div class="wrapper">
                        <a-table
                            :columns="subColumns"
                            :data-source="detail?.subList || []"
                            row-key="id"
                            :pagination="false"
                            size="small"
                            bordered
                            :scroll="{ x: 1600 }"
                        >
                            <template slot="isSignSwitch" slot-scope="text, record">
                                <a-switch :checked="subSignStatus[record.id] !== false" @change="val => handleSubSignChange(record.id, val)" />
                            </template>
                            <template slot="stampTempSelect" slot-scope="text, record">
                                <a-select
                                    :value="subStampTemp[record.id]"
                                    @change="val => handleTempChange(record.id, val)"
                                    style="width: 100px"
                                    allow-clear
                                    placeholder="请选择模板"
                                >
                                    <a-select-option v-for="item in stampTempList" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
                                </a-select>
                            </template>
                            <template slot="drawerNameInput" slot-scope="text, record">
                                <EmployeeSelector
                                    single
                                    :value="subPersonnelData[record.id]?.drawerName?.id ? [subPersonnelData[record.id].drawerName] : []"
                                    @change="(arr) => handleSubPersonChange(record.id, 'drawerName', arr)"
                                >
                                    <a-button block style="text-align: left;">{{ subPersonnelData[record.id]?.drawerName?.name || '请选择' }}</a-button>
                                </EmployeeSelector>
                            </template>
                            <template slot="pizhunInput" slot-scope="text, record">
                                <EmployeeSelector
                                    single
                                    :value="subPersonnelData[record.id]?.pizhun?.id ? [subPersonnelData[record.id].pizhun] : []"
                                    @change="(arr) => handleSubPersonChange(record.id, 'pizhun', arr)"
                                >
                                    <a-button block style="text-align: left;">{{ subPersonnelData[record.id]?.pizhun?.name || '请选择' }}</a-button>
                                </EmployeeSelector>
                            </template>
                            <template slot="xmfzInput" slot-scope="text, record">
                                <EmployeeSelector
                                    single
                                    :value="subPersonnelData[record.id]?.xmfz?.id ? [subPersonnelData[record.id].xmfz] : []"
                                    @change="(arr) => handleSubPersonChange(record.id, 'xmfz', arr)"
                                >
                                    <a-button block style="text-align: left;">{{ subPersonnelData[record.id]?.xmfz?.name || '请选择' }}</a-button>
                                </EmployeeSelector>
                            </template>
                            <template slot="sdInput" slot-scope="text, record">
                                <EmployeeSelector
                                    single
                                    :value="subPersonnelData[record.id]?.sd?.id ? [subPersonnelData[record.id].sd] : []"
                                    @change="(arr) => handleSubPersonChange(record.id, 'sd', arr)"
                                >
                                    <a-button block style="text-align: left;">{{ subPersonnelData[record.id]?.sd?.name || '请选择' }}</a-button>
                                </EmployeeSelector>
                            </template>
                            <template slot="shInput" slot-scope="text, record">
                                <EmployeeSelector
                                    single
                                    :value="subPersonnelData[record.id]?.sh?.id ? [subPersonnelData[record.id].sh] : []"
                                    @change="(arr) => handleSubPersonChange(record.id, 'sh', arr)"
                                >
                                    <a-button block style="text-align: left;">{{ subPersonnelData[record.id]?.sh?.name || '请选择' }}</a-button>
                                </EmployeeSelector>
                            </template>
                            <template slot="zyfzInput" slot-scope="text, record">
                                <EmployeeSelector
                                    single
                                    :value="subPersonnelData[record.id]?.zyfz?.id ? [subPersonnelData[record.id].zyfz] : []"
                                    @change="(arr) => handleSubPersonChange(record.id, 'zyfz', arr)"
                                >
                                    <a-button block style="text-align: left;">{{ subPersonnelData[record.id]?.zyfz?.name || '请选择' }}</a-button>
                                </EmployeeSelector>
                            </template>
                            <template slot="jhInput" slot-scope="text, record">
                                <EmployeeSelector
                                    single
                                    :value="subPersonnelData[record.id]?.jh?.id ? [subPersonnelData[record.id].jh] : []"
                                    @change="(arr) => handleSubPersonChange(record.id, 'jh', arr)"
                                >
                                    <a-button block style="text-align: left;">{{ subPersonnelData[record.id]?.jh?.name || '请选择' }}</a-button>
                                </EmployeeSelector>
                            </template>
                            <template slot="sjInput" slot-scope="text, record">
                                <EmployeeSelector
                                    single
                                    :value="subPersonnelData[record.id]?.sj?.id ? [subPersonnelData[record.id].sj] : []"
                                    @change="(arr) => handleSubPersonChange(record.id, 'sj', arr)"
                                >
                                    <a-button block style="text-align: left;">{{ subPersonnelData[record.id]?.sj?.name || '请选择' }}</a-button>
                                </EmployeeSelector>
                            </template>
                            <template slot="fileLink" slot-scope="text, record">
                                <a href="javascript:void(0)" @click="handleOpenFile(record.attachment)">{{ text }}</a>
                            </template>
                        </a-table>
                    </div>

                    <div class="center">
                        <a-space>
                            <a-button type="primary" @click="submitReview" :loading="submitting">
                                重新提交
                            </a-button>
                            <a-button @click="goBack">返回</a-button>
                        </a-space>
                    </div>
                </a-form>
            </a-skeleton>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import { getDesignStampDetail, resubmitDesignStamp, getStampList } from "@/api/approval/stamp";
import { fetchStampTempList } from "@/api/synergy/stampTemp";
import { queryFileById } from "@/api/project-execute/result";
import FileUpload from "@/components/file-upload";
import { mapMutations } from "vuex";
import EmployeeSelector from "@/components/employee-selector";

const typeMap = {
    cosys_stamp_fadingdaibiaoren: "法定代表人",
    cosys_stamp_jishufuze: "技术负责",
    cosys_stamp_pizhun: "批准",
    cosys_stamp_shejifuze: "设计负责",
    cosys_stamp_shejifuze2: "设计负责2",
    cosys_stamp_zhuanyefuze: "专业负责",
    cosys_stamp_zhuanyefuze2: "专业负责2",
    cosys_stamp_xiaohe: "校核",
    cosys_stamp_shenhe: "审核",
    cosys_stamp_shending: "审定",
    cosys_stamp_sheji: "设计",
    cosys_stamp_sheji2: "设计2",
    cosys_stamp_zhitu: "制图",
    cosys_stamp_zixunyuan: "咨询员",
    cosys_stamp_zhuanyehuijian1: "专业会签1",
    cosys_stamp_zhuanyehuijian2: "专业会签2",
    cosys_stamp_zhuanyehuijian3: "专业会签3",
    cosys_stamp_zhuanyehuijian4: "专业会签4",
    cosys_stamp_zhuanyehuijian5: "专业会签5",
    cosys_stamp_zixunyuan2: "咨询员2",
    cosys_stamp_zixunyuan3: "咨询员3",
    cosys_stamp_shending2: "审定2",
    cosys_stamp_shending3: "审定3",
    cosys_stamp_shending4: "审定4",
    cosys_stamp_xiaohe2: "校核2",
    cosys_stamp_xiaohe3: "校核3",
    cosys_stamp_xiaohe4: "校核4",
    cosys_stamp_xiaohe5: "校核5",
    cosys_stamp_xiaohe6: "校核6",
    cosys_stamp_xiaohe7: "校核7",
    cosys_stamp_xiaohe8: "校核8",
    cosys_stamp_shenhe2: "审核2",
    cosys_stamp_shenhe3: "审核3",
    cosys_stamp_shenhe4: "审核4",
    cosys_stamp_shenhe5: "审核5",
    cosys_stamp_shenhe6: "审核6",
    cosys_stamp_shenhe7: "审核7",
    cosys_stamp_shenhe8: "审核8",
    cosys_stamp_zhuanyefuze3: "专业负责3",
    cosys_stamp_zhuanyefuze4: "专业负责4",
    cosys_stamp_zhuanyefuze5: "专业负责5",
    cosys_stamp_zhuanyefuze6: "专业负责6",
    cosys_stamp_zhuanyefuze7: "专业负责7",
    cosys_stamp_zhuanyefuze8: "专业负责8",
    cosys_stamp_xmfz: "项目负责",
    cosys_stamp_xmfz2: "项目负责2",
};

export default {
    name: "stampReapply",
    components: { FileUpload, EmployeeSelector },
    data() {
        return {
            form: this.$form.createForm(this),
            loading: false,
            submitting: false,
            detail: null,
            stampId: "",
            taskId: "",
            instanceId: "",
            stampUsers: [],
            stampDesignList: [],

            stampRegisterList: [],
            filterByMajor1: false,
            filterByMajor2: false,
            checkboxOptions: [
                { label: '规划', value: '规划' },
                { label: '报规划', value: '报规划' },
                { label: '施工图审查', value: '施工图审查' },
                { label: '施工图', value: '施工图' },
                { label: '竣工验收', value: '竣工验收' },
                { label: '其他', value: '其他' },
            ],
            fileList: [],
            subSignStatus: {},
            subStampTemp: {},
            subPersonnelData: {},
            stampTempList: [],
            subColumns: [
                { title: '流水号', dataIndex: 'serialNo', key: 'serialNo', width: 100 },
                { title: '版本号', dataIndex: 'versionNo', key: 'versionNo', width: 45 },
                { title: '图名', dataIndex: 'name', key: 'name', width: 150 },
                { title: '分图号', dataIndex: 'subDrawingNo', key: 'subDrawingNo', width: 50 },
                { title: '制图人', key: 'drawerName', width: 80, scopedSlots: { customRender: 'drawerNameInput' } },
                { title: '批准', key: 'pizhun', width: 80, scopedSlots: { customRender: 'pizhunInput' } },
                { title: '项目负责', key: 'xmfz', width: 80, scopedSlots: { customRender: 'xmfzInput' } },
                { title: '审定', key: 'sd', width: 80, scopedSlots: { customRender: 'sdInput' } },
                { title: '审核', key: 'sh', width: 80, scopedSlots: { customRender: 'shInput' } },
                { title: '专业负责', key: 'zyfz', width: 80, scopedSlots: { customRender: 'zyfzInput' } },
                { title: '校核', key: 'jh', width: 80, scopedSlots: { customRender: 'jhInput' } },
                { title: '设计', key: 'sj', width: 80, scopedSlots: { customRender: 'sjInput' } },
                { title: '是否签章', dataIndex: 'isSign', key: 'isSign', width: 80, scopedSlots: { customRender: 'isSignSwitch' } },
                { title: '签章模板', dataIndex: 'tempId', key: 'tempId', width: 100, scopedSlots: { customRender: 'stampTempSelect' } },
                { title: '附件', dataIndex: 'name', key: 'fileLink', width: 80, scopedSlots: { customRender: 'fileLink' } },
                { title: '页码', dataIndex: 'pageNumber', key: 'pageNumber', width: 50 },
                { title: '总页数', dataIndex: 'pageCount', key: 'pageCount', width: 50 },
                { title: '纸张尺寸', dataIndex: 'pageSize', key: 'pageSize', width: 60 },
            ],
        };
    },

    mounted() {
        const { taskId, instanceId } = this.$route.query;
        this.taskId = taskId || "";
        this.instanceId = instanceId || "";

        const routeId = this.$route.params.id;
        if (routeId) {
            this.stampId = routeId;
        } else {
            const { businessKey } = this.$route.query;
            if (businessKey) {
                const parts = businessKey.split(":");
                this.stampId = parts.length > 1 ? parts[1] : "";
            }
        }

        if (this.stampId) {
            this.fetchDetail(this.stampId);
            this.loadStampLists();
        }
        if (this.taskId && this.instanceId) {
            this.setTaskId(this.taskId);
            this.setInstanceId(this.instanceId);
        }
    },
    methods: {
        ...mapMutations("approval", ["setTaskId", "setInstanceId"]),
        async loadStampLists() {
            if (this.stampDesignList.length) return;
            try {
                const [designRes, registerRes] = await Promise.all([
                    getStampList({ stampType: 'design' }),
                    getStampList({ stampType: 'register' }),
                ]);
                this.stampDesignList = designRes.list || designRes || [];
                this.stampRegisterList = registerRes.list || registerRes || [];
            } catch (e) {
                console.error('获取签章列表失败', e);
            }
        },
        fetchDetail(id) {
            this.loading = true;
            getDesignStampDetail(id)
                .then((res) => {
                    this.detail = res;
                    const users = (res.userList || []).map((u) => ({
                        ...u,
                        selected: u.userId || u.username
                            ? { userId: u.userId || '', name: u.username || '' }
                            : null,
                    }));
                    this.stampUsers = users;
                    this.loading = false;
                    this.initFileList();
                    this.loadStampTempList();
                    if (res.subList) {
                        res.subList.forEach(s => {
                            this.$set(this.subSignStatus, s.id, s.isSign !== false);
                            this.$set(this.subStampTemp, s.id, s.tempId || undefined);
                            this.$set(this.subPersonnelData, s.id, {
                                drawerName: { id: s.drawerId || '', name: s.drawerName || '' },
                                pizhun: { id: '', name: s.pizhun || '' },
                                xmfz: { id: '', name: s.xmfz || '' },
                                sd: { id: '', name: s.sd || '' },
                                sh: { id: '', name: s.sh || '' },
                                zyfz: { id: '', name: s.zyfz || '' },
                                jh: { id: '', name: s.jh || '' },
                                sj: { id: '', name: s.sj || '' },
                            });
                        });
                    }

                    // ✅ 修复：用 setTimeout 确保 DOM 完全渲染
                    setTimeout(() => {
                        const d = this.detail;
                        const phase = d.phase || {};
                        const personnel = d.personnel || {};
                        const prjPersonnel = personnel.projectPersonnel || {};
                        const purpose = d.drawingPurpose || '';

                        this.form.setFieldsValue({
                            basic_projectName: personnel.projectName || phase.name || "",
                            basic_designNo: phase.designCode || personnel.projectCode || "",
                            basic_prjLeader: prjPersonnel.prjLeaderName || "",
                            basic_majorName: d.majorCode || "",
                            basic_subName: d.subName || "",
                            basic_subCode: d.subCode || "",
                            basic_applicant: d.createName || "",
                            basic_applyDept: d.applyDeptName || phase.mainDeptName || "",
                            // ✅ 关键：undefined 改为 ""，表单校验才认
                            stampDesignId1: d.stampDesignId1 ? String(d.stampDesignId1) : "",
                            stampDesignId2: d.stampDesignId2 ? String(d.stampDesignId2) : "",
                            stampRegisterId1: d.stampRegisterId1 ? String(d.stampRegisterId1) : "",
                            stampRegisterId2: d.stampRegisterId2 ? String(d.stampRegisterId2) : "",
                            drawingDate: d.drawingDate ? moment(d.drawingDate) : null,
                            purposeValues: purpose ? purpose.split(/[、,，]/).filter(Boolean) : [],
                            remark: d.remark || "",
                        });
                    }, 0);
                })
                .catch(() => {
                    this.$message.error("获取签章详情失败");
                    this.loading = false;
                });
        },

        handleUserChange(index, arr) {
            const user = arr.length > 0 ? arr[0] : {};
            this.stampUsers[index].selected = user;
        },

        typeLabel(type) {
            return typeMap[type] || type;
        },

        initFileList() {
            const attachment = this.detail?.attachment;
            if (attachment) {
                try {
                    const parsed = typeof attachment === 'string' ? JSON.parse(attachment) : attachment;
                    this.fileList = Array.isArray(parsed) ? parsed.map(f => ({ id: f.id, name: f.name, finalId: f.finalId || '', finalName: f.finalName || '' })) : [];
                } catch {
                    this.fileList = [];
                }
            } else {
                this.fileList = [];
            }
        },

        handleFinalUpload(list, index) {
            if (list && list.length > 0) {
                const file = list[0];
                const newList = [...this.fileList];
                newList[index] = { ...newList[index], finalId: file.id, finalName: file.name };
                this.fileList = newList;
            }
        },

        handleRemoveAttachment(index) {
            const newList = [...this.fileList];
            newList.splice(index, 1);
            this.fileList = newList;
        },

        handleOpenFile(attachmentId) {
            if (!attachmentId) return;
            queryFileById(attachmentId).then(res => {
                if (res?.completePath) {
                    const url = res.completePath;
                    const filename = this.getFileNameFromUrl(url);
                    if (this.isPdfFile(filename)) {
                        this.previewPdf(url, filename);
                    } else {
                        window.open(url);
                    }
                }
            });
        },
        isPdfFile(filename) {
            return filename && filename.toLowerCase().endsWith('.pdf');
        },
        getFileNameFromUrl(url) {
            const str = String(url || '');
            if (!str) return '';
            const urlWithoutParams = str.split('?')[0];
            let fileName = urlWithoutParams.split('/').pop();
            const idx = fileName.indexOf('_');
            if (idx !== -1) fileName = fileName.substring(idx + 1);
            return decodeURIComponent(fileName);
        },
        previewPdf(url, filename) {
            const routeUrl = this.$router.resolve({
                path: '/pdf-preview',
                query: { url, title: filename || 'PDF预览' }
            }).href;
            window.open(routeUrl, '_blank');
        },

        handleSubPersonChange(id, field, arr) {
            const person = arr[0] || {};
            if (!this.subPersonnelData[id]) {
                this.$set(this.subPersonnelData, id, {});
            }
            this.$set(this.subPersonnelData[id], field, { id: person.id || '', name: person.name || '' });
        },
        handleSubSignChange(id, val) {
            this.$set(this.subSignStatus, id, val);
        },

        handleTempChange(id, val) {
            this.$set(this.subStampTemp, id, val);
        },

        async loadStampTempList() {
            try {
                const res = await fetchStampTempList({ pid: 0 });
                this.stampTempList = Array.isArray(res) ? res : (res.list || []);
            } catch (e) {
                console.error('获取签章模板列表失败', e);
            }
        },

        isRoleDisabled(type) {
            return [
                'cosys_stamp_fadingdaibiaoren',
                'cosys_stamp_jishufuze',
                'cosys_stamp_pizhun',
                'cosys_stamp_shejifuze',
                'cosys_stamp_shejifuze2',
                'cosys_stamp_zhuanyefuze',
                'cosys_stamp_zhuanyefuze2',
                'cosys_stamp_xiaohe',
                'cosys_stamp_shenhe',
                'cosys_stamp_shending',
                'cosys_stamp_sheji',
                'cosys_stamp_sheji2',
                'cosys_stamp_zhitu',
            ].includes(type);
        },

        submitReview() {
            this.form.validateFields((err, formValues) => {
                if (err) return;

                this.submitting = true;
                const userList = this.stampUsers.map((u) => ({
                    type: u.type,
                    userId: u.selected?.userId || u.selected?.id || "",
                    username: u.selected?.name || "",
                }));

                const selectedSubs = (this.detail?.subList || []).filter(s => this.subSignStatus[s.id] !== false);
                const subList = selectedSubs.map(s => ({
                    ...s,
                    isSign: this.subSignStatus[s.id] !== false,
                    tempId: this.subStampTemp[s.id] || s.tempId || undefined,
                    drawerId: this.subPersonnelData[s.id]?.drawerName?.id || s.drawerId || '',
                    drawerName: this.subPersonnelData[s.id]?.drawerName?.name || s.drawerName || '',
                    pizhun: this.subPersonnelData[s.id]?.pizhun?.name || s.pizhun || '',
                    xmfz: this.subPersonnelData[s.id]?.xmfz?.name || s.xmfz || '',
                    sd: this.subPersonnelData[s.id]?.sd?.name || s.sd || '',
                    sh: this.subPersonnelData[s.id]?.sh?.name || s.sh || '',
                    zyfz: this.subPersonnelData[s.id]?.zyfz?.name || s.zyfz || '',
                    jh: this.subPersonnelData[s.id]?.jh?.name || s.jh || '',
                    sj: this.subPersonnelData[s.id]?.sj?.name || s.sj || '',
                }));

                resubmitDesignStamp({
                    id: this.stampId,
                    attachment: this.fileList.length ? JSON.stringify(this.fileList.map(f => ({ id: f.id, name: f.name, finalId: f.finalId || '', finalName: f.finalName || '' }))) : '',
                    stampDesignId1: formValues.stampDesignId1 || "",
                    stampDesignId2: formValues.stampDesignId2 || "",
                    stampRegisterId1: formValues.stampRegisterId1 || "",
                    stampRegisterId2: formValues.stampRegisterId2 || "",
                    drawingType: formValues.drawingType || "",
                    drawingDate: formValues.drawingDate ? formValues.drawingDate.toISOString() : "",
                    drawingPurpose: (formValues.purposeValues || []).join("、"),
                    remark: formValues.remark || "",
                    subList,
                    userList,
                })
                    .then(() => {
                        this.$close(this.$route.path, "/approval/task");
                    })
                    .catch((e) => {
                        console.error("提交失败详情", e);
                        this.$message.error("提交失败");
                    })
                    .finally(() => {
                        this.submitting = false;
                    });
            });
        },

        goBack() {
            this.$close(this.$route.path);
        },
    },
};
</script>

<style lang="less" scoped>
.container {
    background-color: #fff;
    padding: 24px 160px;
}

.wrapper {
    background-color: #f9f9f9;
    padding-top: 24px;
    padding-bottom: 8px;
}

.title {
    font-weight: bold;
    font-size: 17px;
    margin: 12px 0;
}

.center {
    margin-top: 80px;
    display: flex;
    justify-content: center;
}

.file-item {
    display: inline-flex;
    align-items: center;
    padding: 4px 12px;
    margin: 4px;
    background: #fff;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
}
</style>
